// extracted by mini-css-extract-plugin
module.exports = {"root":"Feature4_root__3V6oK","title":"Feature4_title__17AyE"};